<template>
  <v-app>
    <v-dialog v-model="loading" fullscreen transition="fade-transition">
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-layout justify-center align-center>
          <center>
            <v-row :class="percentage ? 'white pa-3 pt-6 border-12' : ''">
              <v-col cols="12">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
              <v-col cols="12" v-if="percentage"
                ><h2 class="primary--text">{{ percentage }}%</h2>
                <div class="primary--text" v-if="percentageDescription">({{ percentageDescription }})</div>
                </v-col
              >
            </v-row>
          </center>
        </v-layout>
      </v-container>
    </v-dialog>

    <NavBar />
    <router-view
      :date="date"
      :id="id"
      :hasRegister="hasRegister"
      :info="info"
      :currentWave="currentWave"
      :sw_status="sw_status"
    ></router-view>
    <Footer />
    <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import NavBar from "./core/NavBar";
import Footer from "./core/Footer";
import { EventBus } from "./event-bus";

import axios from "axios";
import moment from "moment";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    color: "red",
    loading: false,
    percentage: 0,
    student: "",
    date: "",
    sw_id: "",
    id: "",
    hasRegister: false,
    info: "",
    currentWave: "",
    sw_status: "",
    percentageDescription: "",
  }),
  async mounted() {
    EventBus.$on("showSnackbar", (text, color) => {
      // console.log('show snackbar');
      this.text = text;
      this.color = color;
      this.snackbar = true;
    });
    EventBus.$on("startLoading", () => (this.loading = true));
    EventBus.$on("stopLoading", () => {
      this.loading = false;
      this.percentage = 0;
    });
    EventBus.$on("setPercentage", (percentage) => (this.percentage = percentage));
    EventBus.$on("setPercentageDescription", (desc) => (this.percentageDescription = desc));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        // console.log('error in app',error);
        if (error.response.status === 400) {
          if (error.response.data.MESSAGE == "Email already verified") {
            localStorage.setItem("isVerified", true);
            EventBus.$emit("stopLoading");
          }
        } else if (error.response.status === 401) {
          localStorage.clear();
          let hostDestination =
            window.location.hostname === "localhost"
              ? `localhost:${window.location.port}`
              : window.location.hostname;

          window.location.href = `http://${hostDestination}`;
        } else if (error.response.status === 403) {
          // console.log(error.response.data);
          if (
            error.response.data.MESSAGE == "Your email address is not verified"
          ) {
            localStorage.setItem("isVerified", false);
            let hostDestination =
              window.location.hostname === "localhost"
                ? `localhost:${window.location.port}`
                : window.location.hostname;
            let locationWindow = window.location.href.toString();
            let id = localStorage.getItem("id");
            if (
              !locationWindow.includes(
                `http://${hostDestination}/email-verify/${id}`
              )
            ) {
              window.location.href = `http://${hostDestination}/email-verify/${id}`;
            }
          } else {
            localStorage.clear();
            let hostDestination =
              window.location.hostname === "localhost"
                ? `localhost:${window.location.port}`
                : window.location.hostname;

            window.location.href = `http://${hostDestination}`;
          }
        }
        return Promise.reject(error);
      }
    );
    this.id = localStorage.removeItem("date");
    var isVerified = localStorage.getItem("isVerified");

    EventBus.$emit("startLoading");
    await this.checkDate();
    if (
      this.$route.name != "emailVerify" ||
      (this.$route.name != "profile" && isVerified == "false")
    ) {
      await this.cekPengumuman();
    }
    EventBus.$emit("stopLoading");
  },
  methods: {
    checkWave() {
      moment.locale("id");
      const currentTime = moment(this.date);

      const currentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.close)
        );
        return range.contains(currentTime);
      });

      if (currentWave.length > 0) this.currentWave = currentWave;
      else this.currentWave = "";
    },
    async checkDate() {
      this.date = localStorage.getItem("date")
        ? localStorage.getItem("date")
        : "0000-00-00";

      if (!moment().isSame(moment(this.date), "day")) {
        const resDate = await axios.get(`${this.$api}/get-date`);
        this.date = resDate.data.PAYLOAD;
        localStorage.setItem("date", this.date);
      }

      this.checkWave();
    },
    async cekPengumuman() {
      moment.locale("id");

      // const hasCekPengumuman = localStorage.getItem("hasCekPengumuman");
      // if (
      //   hasCekPengumuman == localStorage.getItem("id") ||
      //   !localStorage.getItem("hasRegister")
      // ) return EventBus.$emit("stopLoading");
      let id = localStorage.getItem("id");
      if (localStorage.getItem("id") != null) {
        if (!localStorage.getItem("isVerified")) {
          await axios.post(`${this.$api}/email/check`);
        }
        // console.log("email check");

        const resStudent = await axios.get(`${this.$api}/profile?id=${id}`);
        if (resStudent.data.MESSAGE != "Data siswa tidak valid") {
          localStorage.setItem("sw_status", resStudent.data.PAYLOAD.sw_status);
          this.sw_id = resStudent.data.PAYLOAD.sw_id;
          this.student = resStudent.data.PAYLOAD;

          const res = await axios.get(`${this.$api}/cek-daftar?id=${id}`);
          if (res.data.MESSAGE === "Anda sudah mendaftar.") {
            localStorage.setItem("hasRegister", true);
            if (resStudent.data.MESSAGE != "Data siswa tidak valid") {
              localStorage.setItem(
                "sw_status",
                resStudent.data.PAYLOAD.sw_status
              );
              this.sw_status = resStudent.data.PAYLOAD.sw_status;
            }
            this.hasRegister = true;
            this.info = res.data.PAYLOAD;
          }
        }

        if (
          localStorage.getItem("id") != null &&
          localStorage.getItem("isVerified") == "true"
        ) {
          await this.thingsAfterResult();
        }

        // if (localStorage.getItem("hasDapodik") === null) {
        //   const dapodik = await axios.get(`${this.$api}/check-dapodik`, {
        //     params: { sw_id: this.sw_id },
        //   });
        //   if (dapodik.data.MESSAGE == "Anda belum isi dapodik") {
        //     localStorage.removeItem("hasDapodik");
        //   } else localStorage.setItem("hasDapodik", true);
        // }

        // buat tes doang
        // localStorage.setItem("hasCekPengumuman", localStorage.getItem("id"));

        // if (studentWave.length == 0) return EventBus.$emit("stopLoading");
        // if (moment(this.date).isBefore(moment(studentWave[0].result)))
        //   return EventBus.$emit("stopLoading");
      }
    },

    async thingsAfterResult() {
      try {
        const cekRes = await axios.post(`${this.$api}/cek-pengumuman`, {
          u_id: localStorage.getItem("id"),
        });

        if (cekRes.data.STATUS == "ERROR") {
          localStorage.removeItem("hasCekPengumuman");
        } else if (cekRes.data.PAYLOAD.data.show_pengumuman == "Y") {
          localStorage.setItem("hasCekPengumuman", localStorage.getItem("id"));
        }
      } catch (ex) {
        // console.log(ex);
      }
    },
  },
};
</script>

<style>
* {
  font-family: "Poppins", "Roboto", sans-serif !important;
}

.border-12 {
  border-radius: 12px;
  width: 10rem;
}
</style>